import script from "./BarraBalance.vue?vue&type=script&setup=true&lang=ts"
export * from "./BarraBalance.vue?vue&type=script&setup=true&lang=ts"

import "./BarraBalance.vue?vue&type=style&index=0&id=0b48139c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b48139c"]])

export default __exports__